// extracted by mini-css-extract-plugin
module.exports = {"loader_container":"GlobalLoader_loader_container__bs0gd","loader":"GlobalLoader_loader__m_eQH","loading":"GlobalLoader_loading__2hlxi","spin":"GlobalLoader_spin__age8T"};